/* Signup email verification ("code wall").
 *
 * The address being verified is parked in sessionStorage rather than the URL:
 * it survives a reload of the code screen, is gone when the tab closes, and
 * never ends up in browser history or a shared link.
 */

import { api } from "./api";

const PENDING_KEY = "oe_pending_verification_email";

export function setPendingVerificationEmail(email: string): void {
  try {
    sessionStorage.setItem(PENDING_KEY, email);
  } catch {
    /* private mode / disabled storage — the screen falls back to asking */
  }
}

export function getPendingVerificationEmail(): string {
  try {
    return sessionStorage.getItem(PENDING_KEY) ?? "";
  } catch {
    return "";
  }
}

export function clearPendingVerificationEmail(): void {
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch {
    /* ignore */
  }
}

/** (Re)send the 4-digit code. Always resolves — the API never reveals whether
 *  the address has an account. */
export const requestVerificationCode = (email: string, language: string): Promise<unknown> =>
  api.post("/auth/verify-email/request", { email, language });

/** Confirm the code. On success the backend opens the session, so the caller
 *  should refresh the auth store from the returned payload. */
export const confirmVerificationCode = (email: string, code: string): Promise<unknown> =>
  api.post("/auth/verify-email/confirm", { email, code });
